import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import _ from 'lodash';
import { css, cx } from 'emotion';

import ProcessField from 'components/core/fields/ProcessField';
import InfoMessages from 'components/core/help/InfoMessages';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIERadioGroup from 'components/core/editable/RIERadioGroup';
import RIEToggle from 'components/core/editable/RIEToggle';
import ProcessService from 'services/ProcessService';


const wrapperStyle = css`
    min-width: 650px;
    .editable-container {
        min-width: 650px;
    }
`;

export default class ProcessLogSettingsField extends ProcessField {

    static propTypes = Object.assign({
        runParameters: PropTypes.object,      // pass if running in runParameters mode
        labelWidth: PropTypes.string
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
    }, ProcessField.defaultProps);

    onDebugLevelUpdated = (fieldPath, value) => {
        const parameters = _.cloneDeep(this.props.runParameters);
        parameters['debug_level'] = value;
        if (value === '0') {
            parameters['include_debug_dumps'] = false;
        }
        ProcessService.updateRunParameters(this.props.process.name, parameters);
    };

    onIncludeDatasetDumpsUpdated = (fieldPath, value) => {
        const parameters = _.cloneDeep(this.props.runParameters);
        parameters['include_debug_dumps'] = value;
        ProcessService.updateRunParameters(this.props.process.name, parameters);
    };

    render() {
        const options = {
            '3': 'No transformation debug',
            '4': 'Include transformation debug'
        } ;

        const labelWidth = this.props.labelWidth ? this.props.labelWidth : null;

        return (
            <Flexbox flexDirection="row" alignItems="flex-start" className={cx(wrapperStyle, this.props.className)}>
                <InfoBoxLabel label="Log Settings" width={labelWidth} infoIcon={false} alignTop />

                <Flexbox flexDirection="row" alignItems="flex-start" marginRight="5px">
                    <InfoBoxLabel label="Debug Level" width="95px" message={InfoMessages.debugLevel} alignTop/>
                    <RIERadioGroup
                        value={this.props.runParameters.debug_level}
                        options={options}
                        change={this.onDebugLevelUpdated}
                        formDisplay
                        isDisabled={false}
                        minWidth="245px"
                        radioGroupName="debug-level"
                    />
                </Flexbox>

                {this.props.runParameters.debug_level !== '0' &&
                    <Flexbox flexDirection="row" alignItems="flex-start">
                        <InfoBoxLabel label="Include dataset dumps?" width="166px" hideColon
                                      message={InfoMessages.datasetDumps} alignTop/>
                        <RIEToggle
                            value={this.props.runParameters.include_debug_dumps}
                            change={this.onIncludeDatasetDumpsUpdated}
                            textFalse="No"
                            textTrue="Yes"
                            radioGroupName="include-dataset-dumps"
                            formDisplay
                            isDisabled={false}
                            minWidth="150px"
                        />
                    </Flexbox>
                }

            </Flexbox>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessLogSettingsField.js